import React from 'react';
import { hamburgerPropTypes } from './HamburgerPropTypes';
import Icon from '@Theme/natucare/components/Icon/Icon';
import * as styles from './Hamburger.module.scss';
const Hamburger = ({
  onClick,
  isMobileOpen,
  classname
}) => {
  const iconsSizeAndClassname = {
    size: {
      width: 24,
      height: 24
    },
    classname: styles.rootIcon
  };
  return /*#__PURE__*/React.createElement("div", {
    onClick: onClick,
    className: `${styles.root} ${classname || ''}`
  }, !isMobileOpen && /*#__PURE__*/React.createElement(Icon, Object.assign({
    name: "hamburgerOpen"
  }, iconsSizeAndClassname)), isMobileOpen && /*#__PURE__*/React.createElement(Icon, Object.assign({
    name: "hamburgerClose"
  }, iconsSizeAndClassname)));
};
export default Hamburger;